import {
  Alert,
  Button,
  Col,
  Form,
  Modal,
  Placeholder,
  Row,
  Tab,
  Table,
  Tabs,
} from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { BsArrowLeft } from "react-icons/bs";
import { TiDelete } from "react-icons/ti";
import paginationFactory from "react-bootstrap-table2-paginator";
import moment from "moment";
import { useEffect, useState } from "react";

function EnquiryModal(props) {
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [addressForm, setAddressForm] = useState({});
  const [warningModalTitle, setWarningModalTitle] = useState("Warning");
  const [warningModalBody, setWarningModalBody] = useState(
    "Are you sure you want to cancel this Order?"
  );
  const [warningModalAction, setWarningModalAction] = useState("Cancel Order");

  const {
    show,
    setShow,
    selected,
    selectedOrder,
    selectedOrderLines,
    selectedOrderTracking,
    selectedOrderActivity,
    wmsStatusDescriptions,
    selectedOrderMovements,
    wmsOrderTypes,
    selectedOrderShipping,
  } = props;

  useEffect(() => {
    setAddressForm({
      Addr1: selectedOrder ? selectedOrder.Addr1 : "",
      Addr2: selectedOrder ? selectedOrder.Addr2 : "",
      Addr3: selectedOrder ? selectedOrder.Addr3 : "",
      Addr4: selectedOrder ? selectedOrder.Addr4 : "",
      Postcode: selectedOrder ? selectedOrder.Postcode : "",
    });
  }, [selectedOrder]);

  const linesColumns = [
    {
      dataField: "Line",
      text: "Line",
      sort: true,
    },
    {
      dataField: "Product",
      text: "Product",
      sort: true,
    },
    {
      dataField: "Description",
      text: "Description",
    },
    {
      dataField: "Location",
      text: "Location",
      sort: true,
    },
    {
      dataField: "Qty",
      text: "Quantity",
      sort: true,
    },
    {
      dataField: "Picked",
      text: "Picked",
      sort: true,
    },
    // {
    //   dataField: "Cancel",
    //   text: "Cancel",
    //   formatter: (cell, row) => {
    //     return (
    //       <TiDelete
    //         className="fs-3 text-danger"
    //         style={{ cursor: "pointer" }}
    //         onClick={() => console.log(row)}
    //       />
    //     );
    //   },
    // },
  ];

  const activityColumns = [
    { dataField: "Username", text: "User", sort: true },
    // { dataField: "Datetime", text: "When", sort: true },
    // Format the date to a more readable format
    {
      dataField: "Datetime",
      text: "When",
      formatter: (cell, row) => {
        return moment(row.Datetime).format("YYYY-MM-DD HH:mm:ss");
      },
      sort: true,
    },
    { dataField: "Reference", text: "Reference" },
    { dataField: "Details", text: "Details" },
    { dataField: "PCName", text: "PCName" },
  ];

  const movementsColumns = [
    { dataField: "Product", text: "Product", sort: true },
    { dataField: "Location", text: "Location", sort: true },
    { dataField: "Qty", text: "Qty", sort: true },
    // Format the date to a more readable format
    {
      dataField: "Datetime",
      text: "When",
      formatter: (cell, row) => {
        return moment(row.Datetime).format("YYYY-MM-DD HH:mm:ss");
      },
      sort: true,
    },
    { dataField: "Username", text: "Username", sort: true },
    { dataField: "Analysis", text: "Analysis" },
  ];

  const shippingColumns = [
    { dataField: "Description", text: "Description", sort: true },
    { dataField: "Tracking", text: "Tracking", sort: true },
    { dataField: "Reference", text: "Reference", sort: true },
    { dataField: "Username", text: "Username", sort: true },
    {
      dataField: "Datetime",
      text: "Datetime",
      sort: true,
      formatter: (cell, row) => {
        return moment(row.Datetime).format("YYYY-MM-DD HH:mm:ss");
      },
    },
  ];

  const trackingColumns = [
    { dataField: "Tracking", text: "Tracking", sort: true },
    { dataField: "Status", text: "Status", sort: true },
    { dataField: "Reference", text: "Reference", sort: true },
    {
      dataField: "Datetime",
      text: "Datetime",
      formatter: (cell, row) => {
        return moment(row.Datetime).format("YYYY-MM-DD HH:mm:ss");
      },
    },
  ];

  const cancelOrder = async (orderNo) => {
    try {
      const response = await fetch(`/cancelOrder/${orderNo}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (response.ok) {
        console.log("Order has been cancelled");
        alert("Order has been cancelled");
        // refresh the page
        window.location.reload();
      }
    } catch (error) {
      console.error("Error cancelling order: ", error);
    }
  };

  const updateOrder = async (orderNo) => {
    try {
      const response = await fetch(`/updateOrder/${orderNo}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(addressForm),
      });
      if (response.ok) {
        console.log("Order has been updated successfully");
        alert("Order has been updated successfully");
        // refresh the page
        window.location.reload();
      }
    } catch (error) {
      console.error("Error updating order: ", error);
    }
  };

  const WarningModal = (props) => (
    <Modal
      show={showWarningModal}
      onHide={() => setShowWarningModal(false)}
      backdrop="static"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.5)",
      }}
    >
      <Modal.Header closeButton>
        <Modal.Title>{warningModalTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{warningModalBody}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => setShowWarningModal(false)}>
          Go Back
        </Button>
        <Button
          variant={warningModalAction === "Cancel Order" ? "danger" : "primary"}
          onClick={() => {
            if (warningModalAction === "Cancel Order") {
              cancelOrder(selectedOrder.OrderNo);
            } else if (warningModalAction === "Update Order") {
              updateOrder(selectedOrder.OrderNo);
            }
          }}
        >
          {warningModalAction}
        </Button>
      </Modal.Footer>
    </Modal>
  );
  return (
    <>
      {/* Warning Modal (for cancel & updating action confirmation) */}
      <WarningModal />
      {/* Main Order Modal */}
      <Modal
        show={show}
        onHide={() => setShow(false)}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        style={{
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
            <div className="d-flex align-items-center">
              <BsArrowLeft
                className="mr-2"
                style={{ cursor: "pointer" }}
                onClick={() => setShow(false)}
              />
              <p className="fs-6 fw-light m-0">
                {selectedOrder
                  ? wmsOrderTypes[selectedOrder.Type]
                  : "Order Card"}
              </p>
            </div>
            Order: {selected}
            <p className="fs-6 fw-normal">
              Status:{" "}
              <span
                className={`fw-medium ${
                  selectedOrder && selectedOrder.Status === 9
                    ? "text-danger"
                    : ""
                }`}
              >
                {selectedOrder
                  ? wmsStatusDescriptions[selectedOrder.Status]
                  : ""}
              </span>
            </p>
            {/* <div className="mt-2">
              <p className="m-0 fs-5 fw-normal">Actions</p>
              <div>
                <Button variant="primary" size="sm">
                  Print
                </Button>
                <Button variant="primary" className="mx-1" size="sm">
                  Email
                </Button>
                <Button
                  variant="danger"
                  size="sm"
                  onClick={() => {
                    setShowWarningModal(true);
                    setWarningModalAction("Cancel Order");
                    setWarningModalTitle("Cancel Order");
                    setWarningModalBody(
                      "Are you sure you want to cancel this Order?"
                    );
                  }}
                  disabled={selectedOrder && selectedOrder.Status !== 0} // disable if status is not 'Loaded'
                >
                  Cancel Order
                </Button>
              </div>
            </div> */}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Tabs defaultActiveKey="overview" id="fill-tab-example" className="">
            {/* Header Tabs -- Overview  */}
            <Tab eventKey="overview" title="Overview">
              <Tabs
                defaultActiveKey="details"
                id="justify-tab-example"
                className="mb-4 border-bottom"
                fill
                variant="underline"
              >
                {/* Sub-Overview Tabs --- Details */}
                <Tab eventKey="details" title="Details">
                  <div className="border">
                    <Row>
                      <Col
                        style={{
                          paddingRight: "20px",
                          borderRight: "1px solid #ccc",
                        }}
                      >
                        <div className="px-3 py-4">
                          <Row>
                            <Col sm={2}>
                              <p>Account: </p>
                            </Col>
                            <Col sm={6}>
                              <p className="fw-medium">
                                {selectedOrder ? (
                                  selectedOrder.Account
                                ) : (
                                  <Placeholder as="p" animation="glow">
                                    <Placeholder xs={12} />
                                  </Placeholder>
                                )}
                              </p>
                            </Col>
                          </Row>
                          <Row>
                            <Col sm={2}>
                              <p>Reference: </p>
                            </Col>
                            <Col sm={6}>
                              <p className="fw-medium">
                                {selectedOrder ? (
                                  selectedOrder.CustomerRef
                                ) : (
                                  <Placeholder as="p" animation="glow">
                                    <Placeholder xs={12} />
                                  </Placeholder>
                                )}
                              </p>
                            </Col>
                          </Row>
                          <Row className="mb-3">
                            <Col sm={2}>
                              <p>Address: </p>
                            </Col>
                            <Col sm={6}>
                              <p className="m-0 fw-medium">
                                {selectedOrder ? (
                                  selectedOrder.Addr1
                                ) : (
                                  <Placeholder as="p" animation="glow">
                                    <Placeholder xs={12} />
                                  </Placeholder>
                                )}
                              </p>
                              <p className="m-0 fw-medium">
                                {selectedOrder ? (
                                  selectedOrder.Addr2
                                ) : (
                                  <Placeholder as="p" animation="glow">
                                    <Placeholder xs={12} />
                                  </Placeholder>
                                )}
                              </p>
                              <p className="m-0 fw-medium">
                                {selectedOrder ? (
                                  selectedOrder.Addr3
                                ) : (
                                  <Placeholder as="p" animation="glow">
                                    <Placeholder xs={12} />
                                  </Placeholder>
                                )}
                              </p>
                              <p className="m-0 fw-medium">
                                {selectedOrder ? (
                                  selectedOrder.Postcode
                                ) : (
                                  <Placeholder as="p" animation="glow">
                                    <Placeholder xs={12} />
                                  </Placeholder>
                                )}
                              </p>
                            </Col>
                          </Row>
                          <Row>
                            <Col sm={2}>
                              <p>Contact: </p>
                            </Col>
                            <Col sm={6}>
                              <p className="fw-medium">
                                {selectedOrder ? (
                                  selectedOrder.ContactName
                                ) : (
                                  <Placeholder as="p" animation="glow" />
                                )}
                              </p>
                            </Col>
                          </Row>
                          <Row>
                            <Col sm={2}>
                              <p>Contact No: </p>
                            </Col>
                            <Col sm={6}>
                              <p className="fw-medium">
                                {selectedOrder ? (
                                  selectedOrder.ContactNumber
                                ) : (
                                  <Placeholder as="p" animation="glow" />
                                )}
                              </p>
                            </Col>
                          </Row>
                          <Row>
                            <Col sm={2}>
                              <p>Contact Email: </p>
                            </Col>
                            <Col sm={6}>
                              <p className="fw-medium">
                                {" "}
                                {selectedOrder ? (
                                  selectedOrder.Email
                                ) : (
                                  <Placeholder as="p" animation="glow" />
                                )}
                              </p>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                      {/* Details - right col */}
                      <Col>
                        <div className="px-3 py-4">
                          <Row>
                            <Col sm={2}>
                              <p>Loaded: </p>
                            </Col>
                            <Col sm={6}>
                              <p className="fw-medium">
                                {selectedOrder && selectedOrder.Loaded
                                  ? moment(selectedOrder.Loaded).format(
                                      "YYYY-MM-DD HH:mm:ss"
                                    )
                                  : ""}
                              </p>
                            </Col>
                          </Row>
                          {/* <Row>
                          <Col sm={2}>
                            <p>Ordered: </p>
                          </Col>
                          <Col sm={6}>
                            <p className="fw-medium">2024-02-01 12:34:54</p>
                          </Col>
                        </Row> */}
                          {/* <Row>
                          <Col sm={2}>
                            <p>Loaded to WMS: </p>
                          </Col>
                          <Col sm={6}>
                            <p className="fw-medium">
                              {selectedOrder ? (
                                selectedOrder.Loaded
                              ) : (
                                <Placeholder as="p" animation="glow">
                                  <Placeholder xs={12} />
                                </Placeholder>
                              )}
                            </p>
                          </Col>
                        </Row> */}
                          <Row>
                            <Col sm={2}>
                              <p>Pick Complete: </p>
                            </Col>
                            <Col sm={6}>
                              <p className="fw-medium">
                                {selectedOrder && selectedOrder.Completed
                                  ? moment(selectedOrder.Completed).format(
                                      "YYYY-MM-DD HH:mm:ss"
                                    )
                                  : ""}
                              </p>
                            </Col>
                          </Row>
                          {/* <Row>
                          <Col sm={2}>
                            <p>Picker: </p>
                          </Col>
                          <Col sm={6}>
                            <p className="fw-medium">hardcoded picker</p>
                          </Col>
                        </Row> */}
                          <Row>
                            <Col sm={2}>
                              <p>Route: </p>
                            </Col>
                            <Col sm={6}>
                              <p className="fw-medium">
                                {selectedOrder ? (
                                  selectedOrder.Route
                                ) : (
                                  <Placeholder as="p" animation="glow">
                                    <Placeholder xs={12} />
                                  </Placeholder>
                                )}
                              </p>
                            </Col>
                          </Row>
                          <Row>
                            <Col sm={2}>
                              <p>Site: </p>
                            </Col>
                            <Col sm={6}>
                              <p className="fw-medium">
                                {selectedOrder ? (
                                  selectedOrder.Site
                                ) : (
                                  <Placeholder as="p" animation="glow">
                                    <Placeholder xs={12} />
                                  </Placeholder>
                                )}
                              </p>
                            </Col>
                          </Row>
                          <Row>
                            <Col sm={2}>
                              <p>Status: </p>
                            </Col>
                            <Col sm={6}>
                              <p
                                className={`fw-medium text-${
                                  selectedOrder && selectedOrder.Status === 3 // if status is complete then green text
                                    ? "success"
                                    : ""
                                }`}
                              >
                                {selectedOrder ? (
                                  wmsStatusDescriptions[selectedOrder.Status]
                                ) : (
                                  <Placeholder as="p" animation="glow">
                                    <Placeholder xs={12} />
                                  </Placeholder>
                                )}
                              </p>
                            </Col>
                          </Row>
                          <Row>
                            <Col sm={2}>
                              <p>Consolidated: </p>
                            </Col>
                            <Col sm={6}>
                              <p className="fw-medium">
                                {selectedOrder && selectedOrder.Exported
                                  ? moment(selectedOrder.Exported).format(
                                      "YYYY-MM-DD HH:mm:ss"
                                    )
                                  : ""}
                              </p>
                            </Col>
                          </Row>

                          <Row>
                            <Col sm={2}>
                              <p>Delivery Date: </p>
                            </Col>
                            <Col sm={6}>
                              <p className="fw-medium">
                                {selectedOrder && selectedOrder.DeliveryDate
                                  ? selectedOrder.DeliveryDate
                                  : ""}
                              </p>
                            </Col>
                          </Row>
                          <Row>
                            <Col sm={2}>
                              <p>Comment: </p>
                            </Col>
                            <Col sm={10}>
                              <p
                                className="fw-medium"
                                style={{ wordWrap: "break-word" }} // wrap long text
                              >
                                {selectedOrder ? selectedOrder.Comment : ""}
                              </p>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Tab>
                {/* Sub-Overview Tabs --- Lines*/}
                <Tab
                  eventKey="lines"
                  title={`Lines (${
                    selectedOrderLines ? selectedOrderLines.length : 0
                  })`}
                >
                  <BootstrapTable
                    keyField="Line"
                    data={selectedOrderLines ? selectedOrderLines : []}
                    columns={linesColumns}
                    striped
                    bordered={false}
                    pagination={paginationFactory()}
                  />
                  {/* <Table striped>
                <thead>
                  <tr>
                    <th>OrderNo</th>
                    <th>Line</th>
                    <th>Product</th>
                    <th>Description</th>
                    <th>Location</th>
                    <th>Quantity</th>
                    <th>Picked</th>
                    <th>Cancel</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedOrderLines ? (
                    selectedOrderLines.map((line) => (
                      <tr key={line.Line}>
                        <td>{selected}</td>
                        <td>{line.Line}</td>
                        <td>{line.Product}</td>
                        <td>{line.Description}</td>
                        <td>{line.Location}</td>
                        <td>{line.Qty}</td>
                        <td>{line.Picked}</td>
                        <td className="text-danger">
                          <TiDelete
                            className="fs-3"
                            style={{ cursor: "pointer" }}
                          />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7" className="text-center">
                        <Placeholder as="p" animation="glow">
                          <Placeholder xs={12} />
                        </Placeholder>
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table> */}
                </Tab>
                {/* Sub-Overview Tabs --- Tracking */}
                <Tab
                  eventKey="tracking"
                  title={`Tracking (${
                    selectedOrderTracking ? selectedOrderTracking.length : 0
                  })`}
                >
                  <BootstrapTable
                    keyField="Datetime"
                    data={selectedOrderTracking ? selectedOrderTracking : []}
                    columns={trackingColumns}
                    striped
                    bordered={false}
                    pagination={paginationFactory()}
                  />
                </Tab>
                {/* Sub-Overview Tabs --- Shipping*/}
                <Tab
                  eventKey="Shipping"
                  title={`Shipping (${
                    selectedOrderShipping ? selectedOrderShipping.length : 0
                  })`}
                >
                  <BootstrapTable
                    keyField="ID"
                    data={selectedOrderShipping ? selectedOrderShipping : []}
                    columns={shippingColumns}
                    striped
                    bordered={false}
                    pagination={paginationFactory()}
                  />
                </Tab>
                {/* Sub-Overview Tabs --- Movements */}
                <Tab
                  eventKey="movements"
                  title={`Movements (${
                    selectedOrderMovements ? selectedOrderMovements.length : 0
                  })`}
                >
                  <BootstrapTable
                    keyField="ID"
                    data={selectedOrderMovements ? selectedOrderMovements : []}
                    columns={movementsColumns}
                    striped
                    bordered={false}
                    pagination={paginationFactory()}
                  />
                </Tab>
                {/* Sub-Overview Tabs --- Activity*/}
                <Tab
                  eventKey="activity"
                  title={`Activity (${
                    selectedOrderActivity ? selectedOrderActivity.length : 0
                  })`}
                >
                  <BootstrapTable
                    keyField="When"
                    data={selectedOrderActivity ? selectedOrderActivity : []}
                    columns={activityColumns}
                    striped
                    bordered={false}
                    pagination={paginationFactory()}
                  />
                </Tab>
              </Tabs>
            </Tab>

            {/* Header Tabs -- Edit */}
            {/* <Tab eventKey="edit" title="Edit">
              <Form className="mt-4">
                <Row>
                  <Col>
                    <Form.Group className="mb-3" controlId="">
                      <Form.Label>Address 1</Form.Label>

                      <Form.Control
                        type="text"
                        defaultValue={selectedOrder ? selectedOrder.Addr1 : ""}
                        disabled={selectedOrder && selectedOrder.Status !== 0} // disable if status is not 'Loaded'
                        onChange={(e) => {
                          setAddressForm({
                            ...addressForm,
                            Addr1: e.target.value,
                          });
                        }}
                      />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="">
                      <Form.Label>Address 2</Form.Label>

                      <Form.Control
                        type="text"
                        defaultValue={selectedOrder ? selectedOrder.Addr2 : ""}
                        disabled={selectedOrder && selectedOrder.Status !== 0} // disable if status is not 'Loaded'
                        onChange={(e) => {
                          setAddressForm({
                            ...addressForm,
                            Addr2: e.target.value,
                          });
                        }}
                      />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="">
                      <Form.Label>Address 3</Form.Label>

                      <Form.Control
                        type="text"
                        defaultValue={selectedOrder ? selectedOrder.Addr3 : ""}
                        disabled={selectedOrder && selectedOrder.Status !== 0} // disable if status is not 'Loaded'
                        onChange={(e) => {
                          setAddressForm({
                            ...addressForm,
                            Addr3: e.target.value,
                          });
                        }}
                      />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="">
                      <Form.Label>Address 4</Form.Label>

                      <Form.Control
                        type="text"
                        defaultValue={selectedOrder ? selectedOrder.Addr4 : ""}
                        disabled={selectedOrder && selectedOrder.Status !== 0} // disable if status is not 'Loaded'
                        onChange={(e) => {
                          setAddressForm({
                            ...addressForm,
                            Addr4: e.target.value,
                          });
                        }}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3" controlId="">
                      <Form.Label>Postcode</Form.Label>

                      <Form.Control
                        type="text"
                        defaultValue={
                          selectedOrder ? selectedOrder.Postcode : ""
                        }
                        disabled={selectedOrder && selectedOrder.Status !== 0} // disable if status is not 'Loaded'
                        onChange={(e) => {
                          setAddressForm({
                            ...addressForm,
                            Postcode: e.target.value,
                          });
                        }}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Button
                  variant="secondary"
                  //type="submit"
                  disabled={selectedOrder && selectedOrder.Status !== 0} // disable if status is not 'Loaded'
                  onClick={() => {
                    console.log("Update button clicked");
                    console.log("form state: ", addressForm);
                    setShowWarningModal(true);
                    setWarningModalTitle("Update Order");
                    setWarningModalBody(
                      "Are you sure you want to update this Order?"
                    );
                    setWarningModalAction("Update Order");
                  }}
                >
                  Update
                </Button>
              </Form>
            </Tab> */}
          </Tabs>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default EnquiryModal;
